import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { IonSelect } from '@ionic/angular';

import { GetmIconVariant } from '../../services/getm-icon/getm-icon.service';

export interface SelectFieldOption {
  value: any;
  label: string;
}

export type SelectFieldStatus = 'default' | 'error' | 'disabled';
export type SelectFieldInterface = 'popover' | 'action-sheet' | 'alert';

/**
 * SelectFieldGetm - Selector dropdown GETM
 * Figma Node: 3703-22162
 */
@Component({
  selector: 'app-select-field-getm',
  templateUrl: './select-field-getm.component.html',
  styleUrls: ['./select-field-getm.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectFieldGetmComponent {

  @ViewChild('selectRef', { static: false }) selectRef!: IonSelect;

  @Input() ionic = false;
  @Input() value: any = null;
  @Input() label = '';
  @Input() placeholder = '';
  @Input() supportingText = '';
  @Input() options: SelectFieldOption[] = [];
  @Input() status: SelectFieldStatus = 'default';
  @Input() disabled = false;
  @Input() error = '';
  @Input() showLeftIcon = false;
  @Input() leftIconName = '';
  @Input() variantIcon: GetmIconVariant = 'outline';
  @Input() compareWith: ((o1: any, o2: any) => boolean) | null = null;
  @Input() cancelText = 'Cerrar';
  @Input() okText = 'Aceptar';
  @Input() fill: "outline" | "solid" | undefined = undefined;
  @Input() mode: "ios" | "md" = 'md';
  @Input() interface: SelectFieldInterface = 'popover';

  @Output() valueChange = new EventEmitter<any>();

  public isFocused = false;

  constructor() { }

  public get isDisabled(): boolean {
    return this.disabled || this.status === 'disabled';
  }

  public get isFilled(): boolean {
    return this.value !== null && this.value !== '' && this.value !== undefined;
  }

  public get hasError(): boolean {
    return !!this.error || this.status === 'error';
  }

  public get leftIconColor(): string {
    if (this.isDisabled) return 'var(--color-icons-disabled-default)';
    if (this.hasError) return 'var(--color-icons-error-default)';
    return 'var(--color-icons-neutral-dark)';
  }

  public onSelectionChange(event: CustomEvent): void {
    this.valueChange.emit(event.detail.value);
  }

  public onFocus(): void {
    this.isFocused = true;
  }

  public onBlur(): void {
    this.isFocused = false;
  }

  public trackByOptionValue(_index: number, option: SelectFieldOption): any {
    return option.value;
  }

  public openSelect(event: MouseEvent): void {
    if (this.isDisabled || !this.selectRef) return;

    // Evitar abrir si el click fue directamente en el ion-select (ya se abre solo)
    const target = event.target as HTMLElement;
    if (target.closest('ion-select')) return;

    // Pasar el evento para que el popover se posicione correctamente
    this.selectRef.open(event);
  }
}
